/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./alertConfig.vue?vue&type=template&id=2ad802a4&scoped=true"
import script from "./alertConfig.vue?vue&type=script&lang=js"
export * from "./alertConfig.vue?vue&type=script&lang=js"
import style0 from "./alertConfig.vue?vue&type=style&index=0&id=2ad802a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad802a4",
  null
  
)

export default component.exports